import Configuration from "@/jmeter/components/configurations/configuration";

const DEFAULT_OPTIONS = {
  options: {
    attributes: {
      guiclass: "CacheManagerGui",
      testclass: "CacheManager",
      testname: "HTTP Cache Manager",
      enabled: "true"
    },
  }
};

export default class CacheManager extends Configuration {
  constructor(options = DEFAULT_OPTIONS) {
    options.options.default_attributes = DEFAULT_OPTIONS.options.attributes;
    super(options);

    this.clearEachIteration = this.initBoolProp("clearEachIteration", false)
    this.controlledByThreadGroup = this.initBoolProp("CacheManager.controlledByThreadGroup", false)
    this.useExpires = this.initBoolProp("useExpires", false)
    this.maxSize = this.initIntProp("maxSize", 5000)

  }

  toJson(debug) {
    return super.toJson(debug);
  }
}

export const schema = {
  CacheManager: CacheManager
}
